import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=7d38fa9c&scoped=true"
import script from "./mainBody.vue?vue&type=script&lang=js"
export * from "./mainBody.vue?vue&type=script&lang=js"
import style0 from "./mainBody.vue?vue&type=style&index=0&id=7d38fa9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d38fa9c",
  null
  
)

export default component.exports